import type { KarrotLocalCountryCode } from "@karrotmarket-com/core";
import { AllPageSearchParamKey } from "~/core/AllPageSearchParamKey";
import { CommonSearchParamKey } from "~/core/CommonSearchParamKey";
import { Services } from "~/core/services";
import { useLocale } from "~/remix-lib/useLocale";
import { BuySellSearchParams } from "~/services/buy-sell/buySellSearchParams";
import { GtmVariableName } from "~/utils/GtmVariable";
import { trackSubmitSearchKeyword } from "~/utils/trackEvent";
import { useNormalizeHref } from "~/utils/useNormalizeHref";
import SearchInput from "../common/SearchInput";

type SearchFormProps = {
  karrotLocalCountryCode: KarrotLocalCountryCode;
  region: { id: string; name: string };
  query: string | null;
  searchAutoFocus?: boolean;
};

export function SearchForm(props: SearchFormProps) {
  const { t } = useLocale();
  const { navigateToNormalizedUrl } = useNormalizeHref();

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();

        const keyword = new FormData(event.currentTarget).get(
          CommonSearchParamKey.Search,
        );

        if (typeof keyword === "string") {
          trackSubmitSearchKeyword({
            keyword,
            serviceName: Services.BUY_SELL,
            countryCode: props.karrotLocalCountryCode,
          });

          const searchParams = BuySellSearchParams.stringify(
            {
              regionId: props.region.id,
              search: keyword,
            },
            props.region,
          );

          navigateToNormalizedUrl({
            pathname: `/${props.karrotLocalCountryCode}/${Services.BUY_SELL}/all/`,
            queryString: searchParams,
          });
        }
      }}
    >
      <SearchInput
        data-gtm={GtmVariableName.GnbSearch}
        placeholder={t("GlobalNavigationBar.search_input_placeholder")}
        initialValue={props.query}
        name={AllPageSearchParamKey.Search}
        autoFocus={props.searchAutoFocus}
      />
    </form>
  );
}
